import React from "react";
import logo from "./newlogo.png";

export default function Logo() {
  return (
    <img 
      src={logo} 
      alt="Vaaripa Logo"
      style={{ 
       width: "100%",    
        height: "auto",   
        display: "block",
        marginTop: "-40px",   
        marginBottom: "-40px" 
      }}
    />
  );
}

